import styled from 'styled-components'

export const Wrapper = styled.div`
  .section {
    padding: 1rem 3rem;
    /* border: 2px dotted blue; */
    /* height: 100vh; */
    margin-top: 5rem;

    .main-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      
      margin-top: 2rem;
      /* border: 2px dashed purple; */

      .text {
        justify-content: center;
        /* border: 4px dotted blue; */
        margin: 2rem;
        font-size: 16px;
        text-align: justify;
        letter-spacing: 1px;
        /* width: 500px; */
      }
    }
  }
`;